export const getWhatsappPhone = (item) => {
    var project_name = item.project_name ? `(${item.project_name})`: "";
    return item.phone ? `${item.phone} ${project_name}` : false
}
